// extracted by css-extract-rspack-plugin
export default {"badge":"badge_J8rr"};